import React, {ReactNode, useMemo, useState} from 'react'
import {WorkPackage} from "../../../../../models/responses/work-package.model";
import {useDispatch} from "react-redux";
import {useActiveTaskSelector} from "../../../../../store/selectors/task/task.selectors";
import {useActiveProjectCalendarsSelector, useCpmMapSelector} from "../../../../../store/selectors/project.selectors";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleLeft, faAngleRight, faChevronDown, faChevronUp} from "@fortawesome/free-solid-svg-icons";
import styles from "../WorkPackages.module.scss"
import checklistStyles from "../../ChecklistPage/Checklist.module.scss"
import {ChecklistItemModel} from "../../../../../models/checklist-model";
import WorkPackageChecklistItem from "./WorkPackageChecklistItem";

export default function WorkPackageChecklist (props: {
    checklistItems: ChecklistItemModel[],
    workPackage: WorkPackage,
    infoTag: ReactNode,
}) {
    const dispatch = useDispatch();
    const activeTask = useActiveTaskSelector();
    const cpmMap = useCpmMapSelector();
    const projectCalendars = useActiveProjectCalendarsSelector();
    const [checklistOpen, setChecklistOpen] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);

    const {
        workPackage,
        checklistItems,
    } = props;

    const totalPages = useMemo(() => Math.ceil(checklistItems.length / 10), [checklistItems]);
    const itemsPerPage = 10;

    const renderItems = useMemo(() => {
        if (checklistItems.length > itemsPerPage) {
            if (checklistItems.length < (itemsPerPage * (page - 1))) {
                setPage(1);
            }
            return checklistItems.slice(
                (page - 1) * itemsPerPage,
                (page - 1) * itemsPerPage + itemsPerPage
            );
        }
        setPage(1);
        return checklistItems;
    }, [page, checklistItems, workPackage]);

    const handlePrevClick = (e) => {
        e.stopPropagation();
        if (page > 1) {
            setPage(page - 1);
        }
    };

    const handleNextClick = (e) => {
        e.stopPropagation();
        if (page < totalPages) {
            setPage(page + 1);
        }
    };

    const startItem = (page - 1) * itemsPerPage + 1;
    const endItem = Math.min(page * itemsPerPage, checklistItems.length);

    return (
        <div>
            <div onClick={(e) => {
                // stopEvents(e)
                setChecklistOpen(prevState => !prevState)
            }}
                 className={styles.WorkPackageTasksHeader}>
                <span className={styles.WorkPackageTasksTitle}>
                    <FontAwesomeIcon icon={checklistOpen ? faChevronUp : faChevronDown} size={'lg'} />
                    <span className={styles.TaskHeader}>Pre-flight Checklist ({workPackage.completedChecklist?.length || 0} / {checklistItems.length === 0 ? '0' : checklistItems.length})</span>
                    {props.infoTag}
                </span>
                <div className={styles.RightSideInfoContainer}>
                    {checklistOpen && <div className={styles.CustomPagination}>
                        <div className={styles.number}>
                            {startItem}-{endItem} of {checklistItems.length}
                        </div>
                        <button onClick={handlePrevClick} disabled={page === 1}>
                            <FontAwesomeIcon
                                style={{fontSize: "16px"}}
                                icon={faAngleLeft}
                            />
                        </button>
                        <button onClick={handleNextClick} disabled={page === totalPages}>
                            <FontAwesomeIcon
                                style={{fontSize: "16px"}}
                                icon={faAngleRight}
                            />
                        </button>
                    </div>}
                    {checklistOpen && <div className={styles.HeaderLabels}>
                        <span className={styles.TargetHeader}>Due Date</span>
                        <span className={styles.DeadlineHeader}>Deadline</span>
                    </div>}
                </div>
            </div>
            {checklistOpen && renderItems.map((checklistItem, i) => (
                <div
                    key={`${workPackage.workPackageId}-${checklistItem.checklistItemId}`}
                    id={`${workPackage.workPackageId}-${checklistItem.checklistItemId}`}
                    className={checklistStyles.ChecklistSectionContent}
                >
                    <WorkPackageChecklistItem
                        checklistItem={{...checklistItem, taskId: workPackage.workPackageId}}
                        title={'na'}
                        index={i + 1}
                        workPackage={workPackage}
                    />
                </div>
            ))}
        </div>
    )
}